module.exports = __webpack_public_path__ + "static/media/wordpress-icon.69c22899.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/wordpress-icon.webp
// module id = 245
// module chunks = 1